const stateKeys = ['solarDetail']

export const actions = {
  clearSettings() {
    for (let ix = 0; ix < stateKeys.length; ix++) {
      this.$storage.removeUniversal(stateKeys[ix])
    }
  },
  async getData({ dispatch }) {
    let data = await this.$apiAaltra.settingsSolar()

    if (data && !data.start) {
      data = null
    }

    dispatch('setSolarDetail', { solar: data, reset: true })

    const listData = data
      ? [
          {
            title: this.app.i18n.t('activeInstallation'),
            text: `${this.$formatEpochToShortDate(data.start)} - ${
              data.end
                ? this.$formatEpochToShortDate(data.end)
                : this.app.i18n.t('present')
            }`,
            route: {
              name: 'energy-settings-solar-detail'
            }
          }
        ]
      : []

    return listData
  },
  async setSolarDetail({ dispatch }, { solar, reset }) {
    if (!solar) {
      this.$storage.removeUniversal('solarDetail')
    } else {
      let oldSolar = await dispatch('getSolarDetail')
      if (reset) {
        oldSolar = {}
      }
      this.$storage.setUniversal('solarDetail', { ...oldSolar, ...solar })
    }
  },
  getSolarDetail() {
    return this.$storage.getUniversal('solarDetail')
  },
  async getSolarOverview({ dispatch }) {
    const solarDetail = await dispatch('getSolarDetail')

    const solarExpectations = solarDetail
      ? [
          {
            text: [
              this.app.i18n.t('pvExpectationAvailable'),
              solarDetail.expectation
                ? this.app.i18n.t('yes')
                : this.app.i18n.t('no')
            ]
          },
          {
            text: solarDetail.expectation
              ? [
                  this.app.i18n.t('estimatedYearlySolarYield'),
                  `${this.app.$formatEnergy(
                    solarDetail.expectation
                  )} ${this.app.i18n.t('kwh')}`
                ]
              : [
                  this.app.i18n.t('enterInstalledPvCapacity'),
                  `${this.app.$formatEnergy(
                    solarDetail.capacity
                  )} ${this.app.i18n.t('wp')}`
                ]
          }
        ]
      : null

    const solarExport = solarDetail
      ? [
          {
            text: [
              this.app.i18n.t('exportedEnergyQuestion'),
              solarDetail.exported
                ? this.app.i18n.t('yes')
                : this.app.i18n.t('no')
            ]
          }
        ]
      : null

    if (solarDetail.exported) {
      solarExport.push({
        text: [
          this.app.i18n.t('inputYearlySolorEnergyUsage'),
          solarDetail['exported-kwh-based']
            ? this.app.i18n.t('kwh')
            : this.$currency.get()
        ]
      })
      solarExport.push({
        text: [
          solarDetail['exported-kwh-based']
            ? this.app.i18n.t('myYearlyExportedUsage')
            : this.app.i18n.t('myYearlyExportedPrice'),
          `${this.app.$formatEnergy(solarDetail.exported)} ${
            solarDetail['exported-kwh-based']
              ? this.app.i18n.t('kwh')
              : this.$currency.get()
          }`
        ]
      })
    }

    const solarOverview = [
      { label: this.app.i18n.t('solarExpectations'), rows: solarExpectations },
      { label: this.app.i18n.t('exportedSolarEnergy'), rows: solarExport }
    ]

    return solarOverview
  },
  async saveData(_, { solarSettings }) {
    const apiData = {
      ...solarSettings,
      start: new Date().getTime()
    }
    await this.$apiAaltra.updateSettingsSolar(apiData)
  }
}
